import React from 'react'
import LandingBaggage from '../components/LandingBaggage'
import { Helmet } from 'react-helmet-async'
import Clients from '../components/Clients'
import Contact from '../components/Contact'
import Footer from '../components/Footer'
import BaggageForm2 from '../components/BaggageForm2'
import LandingFooter from '../components/LandingFooter'
import TimeAttendance from '../components/TimeAttendance'

const TimeAttendancePage = () => {
  return (
    <>
      <Helmet>
        <title>TimeWatch Infocom</title>
        <meta
          name="description"
          content="Welcome to TimeWatch Infocom, a leading provider of advanced biometric solutions, access control systems, entrance automation, and parking management technologies. Based in Delhi, we specialize in cutting-edge security solutions designed to enhance safety and efficiency for businesses and organizations. Our innovative time attendance systems, smart security solutions, and reliable surveillance technologies are trusted by industries across India. Explore our products and services, and discover how TimeWatch Infocom is shaping the future of security technology with innovation, quality, and customer satisfaction."
        />
        <link
          rel="canonical"
          href="https://www.timewatchindia.com/"
        />
      </Helmet>
      <div className="d-flex flex-column min-vh-100">
        
        <div>
          <section >
            <TimeAttendance />
          </section>
          
          
          <Clients />
          <BaggageForm2 />
          <LandingFooter />
        </div>
      </div>
    </>
  )
}

export default TimeAttendancePage